import { createAction, createSlice } from '@reduxjs/toolkit';
import { AccountClientGroupRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface ACGState {
    [key: string]: AccountClientGroupRecord; //ACG_ID as key
}

const initialState: ACGState = {};

const initialLoadAction = createAction<{ accountClientGroups: ACGState }>('InitialLoad');
const accountClientGroupRecordAction = createAction<AccountClientGroupRecord>(CoreMsgTypes.AccountClientGroupRecord);

const accountClientGroupSlice = createSlice({
    name: 'accountClientGroups',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                Object.assign(state, action.payload.accountClientGroups);
            })
            .addCase(accountClientGroupRecordAction, (state, action) => {
                if (action.payload.IsDeleted) {
                    delete state[action.payload.ACGId];
                } else {
                    state[action.payload.ACGId] = action.payload;
                }
            })
            .addDefaultCase(state => state);
    }
});

export default accountClientGroupSlice.reducer;